import React from "react"
import { ReactComponent as FaWandMagicSparklesIcon } from "../../../../assets/images/font-awesome-exported/faWandMagicSparkles.svg"
import styles from "./SampleQuestionsAction.module.scss"
import cn from "classnames"
import { useAppDispatch, useAppSelector } from "../../../../store/hooks"
import { selectArticleWorkMode } from "../../../../store/knowledgeBase/selectors"
import { ArticleWorkMode } from "../../../../models/knowledgeBase/workMode"
import TooltipTrigger from "../../../../components/TooltipTrigger/TooltipTrigger"
import { useTranslation } from "react-i18next"
import { resetUnmarkedMessageIfExist, resetUnmarkedMessagesSelection } from "../../../../store/knowledgeBase/slice"

export interface SampleQuestionsActionProps {
    openSidebar: () => void
}

const tNameSpace = "knowledgeBase"

const SampleQuestionsAction = (props: SampleQuestionsActionProps) => {
    const { openSidebar } = props
    const dispatch = useAppDispatch()
    const workMode = useAppSelector(selectArticleWorkMode)
    const { t } = useTranslation(tNameSpace)
    const isEdit = workMode === ArticleWorkMode.Edit

    const handleClick = () => {
        if (isEdit) {
            openSidebar()
            dispatch(resetUnmarkedMessageIfExist())
            dispatch(resetUnmarkedMessagesSelection())
        }
    }

    return (
        <TooltipTrigger
            id={"sample-question"}
            content={t("similar-questions.tooltip")}
            condition={isEdit}
            data-testid={"sample-question-testid"}
            placement={"left"}
        >
            <FaWandMagicSparklesIcon
                className={cn(styles.icon, !isEdit && styles.icon_disabled)}
                onClick={handleClick}
            />
        </TooltipTrigger>
    )
}

export default SampleQuestionsAction
